import React from 'react';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import SFULogo from '../../../application/images/sfu_design/sfu-logo.png';
import './Header.css';
import { APP_TITLE } from '../../../application/common/constants';
import { UserCentralContext } from '../../../application/common/usermanagement';
import config from '../../../application/common/config'

export const Banner: React.FC = () => {
  const isNonProduction = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development' ||
  process.env.NODE_ENV == 'test' || process.env.NODE_ENV == 'stage');
  return (
    <Row className="mb-3">
      <Image src={SFULogo} className="auto-width mt-1" />
      <div className="d-flex justify-content-between mt-2 ">
        <h2 className="ms-5">{APP_TITLE}</h2>
        {UserCentralContext?.CASUser?.ComputingId != null &&
        <p>
          Logged in as <strong>{UserCentralContext?.CASUser?.ComputingId}</strong>
        </p>
        }
      </div>
      {isNonProduction &&
      <Row className="">
        <div className="d-flex justify-content-between mt-2 env-banner">
        <h2 className="ms-5 env-banner-text">{config.ENVIRONMENT} ENVIRONMENT</h2>
      </div>
      </Row>
      }
    </Row>
  );
};
